enum MagicSchool {
  Physical,
  Arcane,
  Fire,
  Frost,
  Nature,
  Shadow,
  Holy
}

export default MagicSchool
